const UTM_STORAGE_KEY = 'utm'

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
]

// Snapshot the entry URL's utm_* params into sessionStorage. Must run before
// anything mutates the URL: captureWhatsAppEntry strips utm_medium at module
// load, and the auth flow replaces the whole query string on redirect — either
// would erase attribution before GA reads it. Merges into (never replaces) the
// stored snapshot, so a re-run after the URL has been partially stripped can't
// drop params captured earlier.
export function captureEntryUtm(): void {
  try {
    const params = new URLSearchParams(window.location.search)
    const utm: Record<string, string> = {}
    UTM_KEYS.forEach((key) => {
      const value = params.get(key)
      if (value) utm[key] = value
    })
    if (Object.keys(utm).length) {
      sessionStorage.setItem(
        UTM_STORAGE_KEY,
        JSON.stringify({ ...getEntryUtm(), ...utm }),
      )
    }
  } catch {
    // private mode / storage blocked
  }
}

export function getEntryUtm(): Record<string, string> {
  try {
    return JSON.parse(sessionStorage.getItem(UTM_STORAGE_KEY) || '{}')
  } catch {
    return {}
  }
}
